import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Modules
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

// Components
import { NgbdDatepickerPopup } from '../components/date-picker.component';
import { DatepicketLocalizationService, I18n } from '../components/date-picker-localization.service';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    NgbdDatepickerPopup
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule
  ],
  exports: [
    NgbdDatepickerPopup
  ],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatepicketLocalizationService }
  ],
})
export class DatePickerModule { }
